const en = {
  translation: {
    welcome: "Welcome!",
    change_language: "Change Language",
    about: "About Page",
    clear_chat_history: "Clear chat history",
    logout: "Logout",
    settings: "Settings",
    user: {
      profile: "Profile",
      user_id: "User ID",
      login_name: "Login name",
      mobile: "Mobile",
      organization: "Organization",
      edit: "Edit",
      edit_coming_soon: "Profile editing is coming soon",
      not_logged_in: "Not signed in. Log in to view your profile.",
    },
    video: {
      play: "Play",
      pause: "Pause",
      forward_10: "Forward 10s",
      rewind_10: "Rewind 10s",
      fullscreen: "Fullscreen"
    }
    ,
    assist: {
      start_guide: "Click to start guide",
      play_guide: "Play guide",
      close: "Close",
      enable_sound: "Enable sound",
      skip: "Skip",
      entered_chat: "You're in the chat"
    }
    ,
    server_error: "Server error, please try again later"
    ,
    course: {
      fetch_failed: "Failed to fetch table data",
      title: "Course List",
      no_data: "No course data available",
      study_course: "I want to study the course '{{name}}'",
      not_started: "Not Started",
      in_progress: "In Progress",
      completed: "Completed"
    }
    ,
    enroll: {
      title: "Training Course Registration Form",
      class: "Class",
      select_class: "Select a class",
      select_class_required: "Please select a class",
      submit_failed: "Failed to submit enrollment",
      name: "Name",
      gender: "Gender",
      male: "Male",
      female: "Female",
      id_card: "ID Number",
      organization_type: "Organization Type",
      organization: "Work Unit",
      position: "Job Title",
      mobile: "Mobile Number",
      email: "Email",
      address: "Address",
      photo: "Photo (optional)",
      submit: "Submit Registration",
      reset: "Reset",
      cancel: "Cancel Registration",
      enter_name: "Please enter name",
      select_gender: "Please select gender",
      enter_id_card: "Please enter ID card number",
      invalid_id_card: "Invalid ID card format",
      enter_mobile: "Please enter mobile number",
      invalid_mobile: "Invalid mobile number format",
      select_org_type: "Please select organization type",
      enter_org: "Please enter work unit",
      select_position: "Please select job title",
      enter_position: "Please enter job title",
      enter_email: "Please enter email",
      invalid_email: "Invalid email format",
      enter_address: "Please enter address",
      upload_one_photo: "Please upload exactly one photo",
      only_images: "Only image files are supported",
      size_exceed: "Image size cannot exceed 5MB",
      upload: "Upload",
      photo_desc: "Optional. For certificate issuance. JPG/PNG, max 5MB",
      submit_success: "Submitted successfully, pending review",
      enroll_info_submitted: "Enrollment submitted, waiting for class teacher review",
      waiting_approval: "Your enrollment has been submitted and is pending review. You can start learning once approved.",
      autofill_notice: "We've auto-filled this form from the details you provided in chat. Please review, complete any missing fields, and submit.",
      upload_failed: "Upload failed",
      enter_mobile_required: "Please enter mobile number",
      invalid_mobile_format: "Invalid mobile number format",
      select_org_type_required: "Please select organization type",
      enter_org_required: "Please enter work unit",
      select_position_required: "Please select position/title",
      enter_email_required: "Please enter email",
      invalid_email_format: "Invalid email format",
      enter_address_required: "Please enter address",
      preview: "Preview"
    }
    ,
    login: {
      welcome: "Welcome to use",
      brand: "Shanhai Zhixun",
      wechat_login: "WeChat Login"
    },
    logout: "Logout",
    talk: {
      thinking: "Thinking...",
      open_dynamic: "Open Dynamic",
      upload_video: "Open Upload Video",
      open_enroll: "Open Enrollment Form",
      open_table: "Open Table",
      open_course_table: "Open Course Schedule",
      open_course: "Open Course",
      open_class_list: "Open Class List"
    }
    ,
    action_card: {
      enroll_title: "Course Enrollment",
      enroll_desc: "Tap to open the form, or tell me your details in chat and I will fill it for you.",
      video_title: "Continue Learning",
      video_desc: "Open the recommended course video.",
      schedule_title: "Learning Progress",
      schedule_desc: "View your schedule and learning progress.",
      class_list_title: "Class List",
      class_list_desc: "Browse available or enrolled classes.",
      certificate_title: "View Certificate",
      certificate_desc: "Open your completion certificate.",
      generic_title: "View Details",
      generic_desc: "Tap to open this feature."
    }
    ,
    input: {
      voice_not_available: "Voice feature not yet available, please stay tuned",
      file_too_large: "File {{name}} exceeds 500MB limit",
      upload_success: "{{name}} uploaded successfully",
      upload_failed: "{{name}} upload failed",
      upload_error: "{{name}} upload failed: {{error}}",
      file_deleted: "File deleted",
      enter_question: "Please enter your question",
      upload_file: "Upload file",
      voice_input: "Voice input",
      voice_listening: "Listening… speak now",
      voice_transcribing: "Recognizing speech…",
      voice_stop: "Tap to stop",
      voice_not_supported: "Voice input is not supported in this browser",
      voice_no_speech: "No speech detected, please try again",
      voice_permission_denied: "Microphone permission denied",
      voice_error: "Voice recognition failed, please try again",
      delete_file: "Delete file",
      processing: "Processing your question...",
      ask_question: "Ask your question"
    },
    energy: {
      label: "Energy",
      summary: "Monthly total {{total}}, used {{used}}, remaining {{remain}}",
      consumed: "Used {{cost}} energy this time",
      insufficient: "Insufficient energy for AI features",
      unavailable: "Energy info unavailable"
    }
    ,
    talk_input: {
      ask_any_question: "Ask me any question"
    }
    ,
    quick_questions: {
      enroll: "I want to enroll",
      continue_learning: "Continue learning",
      learning_progress: "Learning progress",
      take_course: "I want to take a course",
      chat: "Chat casually",
      query: "I want to query",
      upload_video: "I want to upload video"
    }
    ,
    video_player: {
      fetch_video_failed: "Failed to get video info",
      save_progress_failed: "Failed to save watch progress",
      updating_learning_record: "Updating your learning record, please wait…",
      lesson_complete_message: "You've finished this lesson. Hope today's content brings you new inspiration — keep making progress in practice!",
      course_completed: "Completed course",
      course_interrupted: "Interrupted course",
      send_progress_failed: "Failed to send watch progress to AI:",
      back_to_list: "Back to List",
      speed: "Speed",
      play_count: "Play count"
    }
    ,
    video_list: {
      title: "Video Course List",
      total_courses: "Total {{count}} courses",
      learning_progress: "Learning Progress",
      continue_learning: "Continue Learning",
      start_learning: "Start Learning"
    }
    ,
    course_types: {
      required: "Required Course",
      elective: "Elective Course",
      lab: "Lab Course"
    }
    ,
    class_list: {
      title: "Class List",
      sort: "Sort",
      class_name: "Class Name",
      program_type: "Program Type",
      deadline: "Deadline",
      action: "Action",
      join_class: "Join Class",
      no_deadline: "No deadline",
      fetch_failed: "Failed to fetch table data"
    }
    ,
    common: {
      back: "Back",
      loading: "Loading...",
      no_data: "No data"
    }
    ,
    window: {
      collapse_display: "Collapse",
      close_modal: "Close",
      display_digital_human: "Learning Assistant",
      display_video: "Course Video",
      chat_panel: "Chat"
    }
    ,
    certificate: {
      title: "Certificate",
      download: "Download PDF",
      downloading: "Generating…",
      download_failed: "Could not download the certificate. Please try again.",
      paused: "The certificate template is being updated. Issuance is paused until the new version is available."
    }
    ,
    table: {
      course_type: "Course Type"
    }
    ,
    teacher_profile: {
      title: "Teacher Profile",
      job_title: "Title",
      position: "Position",
      phone: "Phone",
      email: "Email",
      work_unit: "Organization",
      bio: "About",
      view_photo: "View photo"
    },
    course_schedule: {
      title: "Course Schedule",
      title_lessons: "Lesson List",
      title_agenda: "Training Agenda",
      program_type: "Program Type",
      has_video: "Has video",
      no_video: "No video",
      video_status: "Video",
      sort: "Sort",
      course_type: "Course Type",
      name: "Name",
      learning_progress: "Learning Progress",
      teacher: "Teacher",
      not_started: "Not Started",
      fetch_failed: "Failed to fetch table data"
    },
    lesson_list: {
      title: "Lesson List",
      has_video: "Has video",
      no_video: "No video"
    },
    program_type: {
      agenda_required: "Agenda required",
      agenda_optional: "Agenda optional",
      agenda_not_required: "No agenda required"
    }
  }
};

export default en;
